import { render, staticRenderFns } from "./pivots-table.component.vue?vue&type=template&id=efa3ce8e"
import script from "./pivots-table.component.vue?vue&type=script&lang=ts"
export * from "./pivots-table.component.vue?vue&type=script&lang=ts"
import style0 from "./pivots-table.component.vue?vue&type=style&index=0&id=efa3ce8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports